module.exports = __webpack_public_path__ + "static/media/andrew.435f6b71.jpg";